define('../app/fukit/view/block/searchable.table.view',['require','exports','module','underscore','uikit/uikit','../../helpers/extend.util','./notpageable.table.view','../../behavior/visual.search.behavior'],function(require, exports, module) {
    //prettier-ignore
    var _                    = require('underscore'),
        UIKit                = require('uikit/uikit'),
        ExtendUtil           = require('../../helpers/extend.util'),
        NotPageableTableView    = require('./notpageable.table.view'),
        VisualSearchBehavior = require('../../behavior/visual.search.behavior');

    var SearchableTableView = NotPageableTableView.extend({
        template: function() {
            return (
                '<div><ui name="visualSearchView" /></div>' +
                '<ui name="tableView" />'
            );
        },

        options: _.extend({}, NotPageableTableView.prototype.options, {
            attached: 'bottom',
        }),

        internalViewOptions: NotPageableTableView.extendInternalViewOptions({
            visualSearchView: ExtendUtil.extendOptionValueWithDefaults('visualSearch', function() {
                return {
                    type: UIKit.TokenInput,
                    singleValue: false,
                    freeText: false,
                    validateToken: function(token) {
                        return token.get('value') ? true : '';
                    },
                    icon: 'search',
                    placeholder: 'Click to search...',
                    behaviors: {
                        VisualSearchBehavior: {
                            behaviorClass: VisualSearchBehavior,
                            availableFields: this.getOption('searchFields'),
                            searchResultCollection: this.collection,
                            escapeSpecialChars: this.getOption('escapeSpecialChars'),
                            specialCharRegEx: this.getOption('specialCharRegEx'),
                        },
                    },
                };
            }),
        }),
    });
    module.exports = SearchableTableView;
});




